import { useQuery } from "@tanstack/react-query";
import { getActivitiesFeed, reprogramActivity, createActivity, createNewSessionActivity, createRecurringActivities } from "@/services/activityService";
import type { CreateActivityDto } from '@/lib/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { ActivityFeedParams } from "@/lib/types";

export const activityKeys = {
  all: ["activities"] as const,
  feeds: () => [...activityKeys.all, "feed"] as const,

  feed: (params?: ActivityFeedParams) =>
    [...activityKeys.feeds(), params ?? {}] as const,
  map: () => [...activityKeys.all, "map"] as const,
};

export function useActivitiesFeed(params?: ActivityFeedParams) {
  return useQuery({
    queryKey: activityKeys.feed(params),
    queryFn: () => getActivitiesFeed(params),
  });
}


export function useCreateActivity() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (dto: CreateActivityDto) =>
      createActivity(dto),

    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['home-feed'],
      });

      await queryClient.invalidateQueries({
        queryKey: ['activities'],
      });
    },
  });
}



export function useReprogramActivity() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, startsAt, endsAt }: { id: string; startsAt: string; endsAt?: string | null; }) =>
      reprogramActivity(id, { startsAt, endsAt, }),

    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['home-feed'],
      });

      await queryClient.invalidateQueries({
        queryKey: ['activities'],
      });
    },
  });
}



export function useCreateNewSessionActivity() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, startsAt, endsAt, }: { id: string; startsAt: string; endsAt?: string | null; }) =>
      createNewSessionActivity(id, { startsAt, endsAt, }),

    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['home-feed'],
      });

      await queryClient.invalidateQueries({
        queryKey: ['activities'],
      });
    },
  });
}




export function useCreateRecurringActivities() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, startsAt, endsAt, intervalWeeks, occurrences, }:
      { id: string; startsAt: string; endsAt?: string | null; intervalWeeks: number; occurrences: number; }) =>
      createRecurringActivities(id, {
        startsAt,
        endsAt,
        intervalWeeks,
        occurrences,
      }),

    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['home-feed'],
      });

      await queryClient.invalidateQueries({
        queryKey: ['activities'],
      });
    },
  });
}